/* eslint-disable react-hooks/exhaustive-deps */
import 'antd/dist/antd.min.css';
import 'antd.css';
import React from 'react';
import SimpleTable from 'components/table/SimpleTable';
import SumarryTable from 'components/table/SumarryTable';
import LoadingContent from 'components/LoadingContent';
import { useHistory, useParams } from 'react-router-dom';
import gpaForecastServices from 'services/gpaforecast.services';
import gpaForecastDetailServices from 'services/gpaforecastDetail.services';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import { useAppDispatch } from 'app/hooks';
import { routers } from 'router/router';
import { getAccessToken, removeUserId, removeAccessToken } from 'utils/sessionStorage';

const GPAForecasterSummary = () => {
  const [gpaForecast9Data, setGpaForecast9Data] = React.useState<any[]>([]);
  const [gpaForecast9Custom, setGpaForecast9Custom] = React.useState<any[]>([]);
  const [gpaForecast9Average, setGpaForecast9Average] = React.useState<any[]>([]);
  const [gpaForecast10Data, setGpaForecast10Data] = React.useState<any[]>([]);
  const [gpaForecast10Custom, setGpaForecast10Custom] = React.useState<any[]>([]);
  const [gpaForecast10Average, setGpaForecast10Average] = React.useState<any[]>([]);
  const [gpaForecast11Data, setGpaForecast11Data] = React.useState<any[]>([]);
  const [gpaForecast11Custom, setGpaForecast11Custom] = React.useState<any[]>([]);
  const [gpaForecast11Average, setGpaForecast11Average] = React.useState<any[]>([]);
  const [gpaForecast12Data, setGpaForecast12Data] = React.useState<any[]>([]); 
  const [gpaForecast12Custom, setGpaForecast12Custom] = React.useState<any[]>([]);
  const [gpaForecast12Average, setGpaForecast12Average] = React.useState<any[]>([]);

  const [loading, setLoading] = React.useState(false);
  const params: { id?: string | number } = useParams();
  const dispatch = useAppDispatch();
  const history = useHistory();

 let token = getAccessToken();
 
  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const getGpaDetails = async(studentId: string, gradeNo: number) => {
    let arr:any[] = [];
    const ret:any[] = await gpaForecastServices.getGpaForeCastByGradeNo(studentId, gradeNo);
    if (ret && ret.length>0) {
      for (let i=0; i<ret.length; i++) {
          let item = ret[i];
          let ret2:any[] = await gpaForecastDetailServices.getGpaForeCastDetails(item.gpa_forecast_id);
          if (ret2 && ret2.length>0) {
            for(let j=0; j<ret2.length; j++) {
              arr.push(ret2[j]);
            }
          }
      }        
    }
    return arr;
  }

  const formatDecial =(num:number) =>{
    return (Math.round(num * 100) / 100).toFixed(2);
  } 
  
  const calcAverageGpa = (data:any[]) => {
    if (data && data.length>0) {
      let sum1 = 0;
      let sum2 = 0;
      let sumCredit = 0;
      for(let i=0; i< data.length; i++) {
        sum1 += data[i].unweighted_point * data[i].credit;
        sum2 += data[i].weighted_point * data[i].credit;
        sumCredit += data[i].credit;
      }
      return { 
        unweighted_point: sum1 > 0 ? sum1/sumCredit : 0, 
        weighted_point:   sum2 > 0 ? sum2/sumCredit : 0, 
      }
    }
    return { unweighted_point: 0, weighted_point: 0 }
  }

  const CalcAverageGpaPoint = (data:any[], gradeNo: number) => {
    let gradeth = `${gradeNo}th Grade`;
    if (data && data.length>0) {
      let sum1 = 0;
      let sum2 = 0;
      let sumCredit = 0;
      for(let i=0; i< data.length; i++) {
        sum1 += data[i].unweighted_point * data[i].credit;
        sum2 += data[i].weighted_point * data[i].credit;
        sumCredit += data[i].credit;
      }
      return [{ 
        grade: gradeth, 
        unweighted_point: sum1 > 0 ? formatDecial(sum1/sumCredit) : 0, 
        weighted_point:   sum2 > 0 ? formatDecial(sum2/sumCredit) : 0,
      }]
    }
    return [{ grade: gradeth, unweighted_point: 0, weighted_point: 0}]
  }


  const CalcAverageGpa_10Grade = (data9:any[], data10:any[]) => {
    let gradeth = '9th-10th Grade';
    let arr:any[] = [];
    let avg9:any = calcAverageGpa(data9);
    let avg10:any = calcAverageGpa(data10);
    let unweighted_point = (avg9.unweighted_point + avg10.unweighted_point) /2;
    let weighted_point= (avg9.weighted_point + avg10.weighted_point) /2;
    arr.push(CalcAverageGpaPoint(data10, 10)[0]);
    arr.push({grade: gradeth, unweighted_point: formatDecial(unweighted_point), weighted_point: formatDecial(weighted_point)});
    return arr;
  }

  const CalcAverageGpa_11Grade = (data9:any[], data10:any[], data11:any[]) => {
    let grade_9_11th = '9th-11th Grade';
    let grade_10_11th = '10th-11th Grade';  
    let arr:any[] = []; 
    let avg9:any = calcAverageGpa(data9);
    let avg10:any = calcAverageGpa(data10);
    let avg11:any = calcAverageGpa(data11);
    let unweighted_point_9_11 = (avg9.unweighted_point + avg10.unweighted_point + avg11.unweighted_point) /3;
    let weighted_point_9_11= (avg9.weighted_point + avg10.weighted_point + avg11.weighted_point) /3;
    arr.push(CalcAverageGpaPoint(data11, 11)[0]);
    arr.push({grade: grade_9_11th, unweighted_point: formatDecial(unweighted_point_9_11), weighted_point: formatDecial(weighted_point_9_11)});
    let unweighted_point_10_11 = (avg10.unweighted_point + avg11.unweighted_point) /2;
    let weighted_point_10_11= (avg10.weighted_point + avg11.weighted_point) /2;
    arr.push({grade: grade_10_11th, unweighted_point: formatDecial(unweighted_point_10_11), weighted_point: formatDecial(weighted_point_10_11)});   
    return arr;
  }

  const CalcAverageGpa_12Grade = (data9:any[], data10:any[], data11:any[], data12:any[]) => {
    let grade_9_12th = '9th-12th Grade';
    let grade_10_12th = '10th-12th Grade';  
    let arr:any[] = []; 
    let avg9:any = calcAverageGpa(data9);
    let avg10:any = calcAverageGpa(data10);
    let avg11:any = calcAverageGpa(data11);
    let avg12:any = calcAverageGpa(data12);
    let unweighted_point_9_12 = (avg9.unweighted_point + avg10.unweighted_point + avg11.unweighted_point + avg12.unweighted_point) /4;
    let weighted_point_9_12= (avg9.weighted_point + avg10.weighted_point + avg11.weighted_point + avg12.weighted_point) /4;
    arr.push(CalcAverageGpaPoint(data12, 12)[0]);
    arr.push({grade: grade_9_12th, unweighted_point: formatDecial(unweighted_point_9_12), weighted_point: formatDecial(weighted_point_9_12)});
    let unweighted_point_10_12 = (avg10.unweighted_point + avg11.unweighted_point + avg12.unweighted_point) /3;
    let weighted_point_10_12= (avg10.weighted_point + avg11.weighted_point + avg12.weighted_point) /3;
    arr.push({grade: grade_10_12th, unweighted_point: formatDecial(unweighted_point_10_12), weighted_point: formatDecial(weighted_point_10_12)});   
    return arr;
  }

  const getData = async () => {
    token = getAccessToken();
    if (token && params.id) {
      let studentId = `${params.id}`;
      setLoading(true);
      try { 
        let arr9 = await getGpaDetails(studentId, 9);
        let arr9_origin:any[] = arr9.filter( (item:any) => (item.is_custom === false));
        setGpaForecast9Data(arr9_origin);
        let arr9_custom:any[] = arr9.filter( (item:any) => (item.is_custom === true));
        setGpaForecast9Custom(arr9_custom);
        setGpaForecast9Average(CalcAverageGpaPoint(arr9, 9));
  
        let arr10 = await getGpaDetails(studentId, 10);
        let arr10_origin:any[] = arr10.filter( (item:any) => (item.is_custom === false));
        setGpaForecast10Data(arr10_origin);
        let arr10_custom:any[] = arr10.filter( (item:any) => (item.is_custom === true));
        setGpaForecast10Custom(arr10_custom);
        setGpaForecast10Average(CalcAverageGpa_10Grade(arr9, arr10));
  
        let arr11 = await getGpaDetails(studentId, 11);
        let arr11_origin:any[] = arr11.filter( (item:any) => (item.is_custom === false));
        setGpaForecast11Data(arr11_origin);
        let arr11_custom:any[] = arr11.filter( (item:any) => (item.is_custom === true));
        setGpaForecast11Custom(arr11_custom);
        setGpaForecast11Average(CalcAverageGpa_11Grade(arr9, arr10, arr11));
        
        let arr12 = await getGpaDetails(studentId, 12);
        let arr12_origin:any[] = arr12.filter( (item:any) => (item.is_custom === false));
        setGpaForecast12Data(arr12_origin);
        let arr12_custom:any[] = arr12.filter( (item:any) => (item.is_custom === true));
        setGpaForecast12Custom(arr12_custom);
        setGpaForecast12Average(CalcAverageGpa_12Grade(arr9, arr10, arr11, arr12));
      }
      catch(ex) {
        console.log('Error: ', ex);
      }    
      setLoading(false);
    } else {
      handleLogout();
    }
  };

  React.useEffect(() => {
    if (!loading) {
      params.id !== ':id' && getData();
    }
  }, [params.id]);

  React.useEffect(() => {
    const syncData = async () => {
      if (!loading) {
        let studentId = `${params.id}`;
        const ret:any = await gpaForecastServices.syncGpaForecast(studentId);
        if (ret && ret.statusCode === 200) {
          await getData();
        }
      }
    };
    syncData();
  }, []);


  const gradeColumns = [
    { label: 'School Name', value: 'school_name', sx: {width:'20%'}},
    { label: 'Course', value: 'course', sx: {width:'20%', }},
    { label: 'Term', value: 'term',sx: {
      width: {
        md: '7%',
        lg: '8%',
        xl: '10%',
      }
    }},
    { label: 'Grade', value: 'grade', sx: {
      width: {
        md: '7%',
        lg: '8%',
        xl: '10%',
      }
    }},
    { label: 'Unweighted Point', value: 'unweighted_point', sx: {
      width: {
        md: '12%',
        lg: '8%',
        xl: '10%',
      },
    }},
    { label: 'Weighted point', value: 'weighted_point', sx: {
      width: {
        md: '12%',
        lg: '8%',
        xl: '10%',
      },
      minWidth: '100px',
    }},
    { label: 'Credits', value: 'credit', sx: {
      width: {
        md: '7%',
        lg: '8%',
        xl: '10%',
      }
    }},
  ];

  const summaryColumns = [
    { label: '', value: 'grade', fontsize5: true},
    { label: 'Unweighted Point', value: 'unweighted_point', align: 'center'},
    { label: 'Weighted point', value: 'weighted_point', align: 'center'},
  ];


  return loading ? (
      <LoadingContent />
    ) : (
    <>
        <div className="row w-100">
            <div className="col-md-12 py-4">
            <h2>Grade 9th</h2>
            </div>
            <div className="col-md-12">
            <SimpleTable
                equalColumns={true}
                column={gradeColumns}
                data = {gpaForecast9Data}
            />
            </div>
            <div className="col-md-12 py-3">
            <h3 className="fs-6">Grade 9th - Custom Data</h3>
            <SimpleTable
                equalColumns={true}
                column={gradeColumns}
                data = {gpaForecast9Custom}
            />
            </div>
            <div className="d-flex w-100 justify-content-end pb-4">
            <div className="d-flex">
            <SumarryTable
                column={summaryColumns}
                data = {gpaForecast9Average}
                minWidth={120}
                />
            </div>
            </div>
            <hr/>

            <div className="col-md-12 py-4">
            <h2>Grade 10th</h2>
            </div>
            <div className="col-md-12">
            <SimpleTable
                equalColumns={true}
                column={gradeColumns}
                data = {gpaForecast10Data}
            />
            </div>
            <div className="col-md-12 py-3">
            <h3 className="fs-6">Grade 10th - Custom Data</h3>
            <SimpleTable
                equalColumns={true}
                column={gradeColumns}
                data = {gpaForecast10Custom}
            />
            </div>
            <div className="d-flex w-100 justify-content-end pb-4">
            <div className="d-flex">
            <SumarryTable
                column={summaryColumns}
                data = {gpaForecast10Average}
                minWidth={120}
                />
            </div>
            </div>
            <hr/>

            <div className="col-md-12 py-4">
            <h2>Grade 11th</h2>
            </div>
            <div className="col-md-12">
            <SimpleTable
                equalColumns={true}
                column={gradeColumns}
                data = {gpaForecast11Data}
            />
            </div>
            <div className="col-md-12 py-3">
            <h3 className="fs-6">Grade 11th - Custom Data</h3>
            <SimpleTable
                equalColumns={true}
                column={gradeColumns}
                data = {gpaForecast11Custom}
            />
            </div>
            <div className="d-flex w-100 justify-content-end pb-4">
            <div className="d-flex">
            <SumarryTable
                column={summaryColumns}
                data = {gpaForecast11Average}
                minWidth={120}
                />
            </div>
            </div>
            <hr />

            <div className="col-md-12 py-4">
            <h2>Grade 12th</h2>
            </div>
            <div className="col-md-12">
            <SimpleTable
                equalColumns={true}
                column={gradeColumns}
                data = {gpaForecast12Data}
            />
            </div>
            <div className="col-md-12 py-3">
            <h3 className="fs-6">Grade 12th - Custom Data</h3>
            <SimpleTable
                equalColumns={true}
                column={gradeColumns}
                data = {gpaForecast12Custom}
            />
            </div>
            <div className="d-flex w-100 justify-content-end pb-4">
            <div className="d-flex">
            <SumarryTable
                column={summaryColumns}
                data = {gpaForecast12Average}
                minWidth={120}
                />
            </div>
            </div>
        </div>

        <style scoped>{`
button.position-absolute.text-primary.btn.btn-outline {
  width: 45px!important;
  height: 45px!important;
}      
.main-statistic {
  padding: 0px 8px;
}
@media screen and (min-width: 992px) {
  .main-statistic {
    padding: 0px 64px;
  }
}

th.MuiTableCell-root.MuiTableCell-head.MuiTableCell-sizeMedium {
  font-weight: bold;
  padding: 12px 8px;
  line-height: normal;
}
td.MuiTableCell-root.MuiTableCell-body.MuiTableCell-sizeMedium {
  padding: 5px;
}
      `}
      </style>
      </>
    );
};

export default GPAForecasterSummary;
